export const AUTH_ERROR_MESSAGES = {
  empty_password: "Please enter your password",
  empty_email: "Please enter your email address",
  invalid_email: "We couldn't find a member with those details",
  invalidcombo: "Invalid Combo",
  empty_username: "Please enter your member number",
  invalid_username: "We couldn't find a member with that number",
  incorrect_password: "The password you entered is incorrect",
  retrieve_password_email_failure: "We couldn't find a member with that email address",
} as Record<string, string>
